module.exports = __webpack_public_path__ + "img/跳绳.1371d4d9.gif";